<template>
  <div class="figma-test">
    <div v-if="isPopupOpen" class="dim">
      <div class="popup">
        <div class="popup__contents">
          <img class="popup__image" src="@/assets/figmatest/img_consent.gif" alt="" />
          <div class="popup__text">
            <p class="popup__title">위임장을 등록할까요?</p>
            <p class="popup__message">등록 후 대리인이<br />진료 예약 및 접수를 진행할 수 있어요.</p>
          </div>
        </div>
        <div class="popup__buttons">
          <button type="button" class="popup__button popup__button--close" @click="isPopupOpen = false">닫기</button>
          <button type="button" class="popup__button popup__button--confirm">등록하기</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FigmaTest',
  data: function () {
    return {
      isPopupOpen: true,
    };
  },
};
</script>

<style scoped>
.figma-test {
  --color-text-heavy: #191f28;
  --color-text-strong: #4e5968;
  --color-bg-dimmed: rgba(24, 24, 28, 0.8);
  --color-secondary-light: #f2f4f6;
  --color-primary-normal: #0096ff;

  min-height: 100vh;
  background: #fff;
  font-family: 'Pretendard', sans-serif;
}

.figma-test *,
.figma-test *::before,
.figma-test *::after {
  box-sizing: border-box;
}

p {
  margin: 0;
}

button {
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  font-family: inherit;
  cursor: pointer;
}

.dim {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--color-bg-dimmed);
}

.popup {
  display: flex;
  flex-direction: column;
  width: 320px;
  gap: 16px;
  align-items: center;
  padding: 20px 16px 16px;
  border-radius: 20px;
  background: #fff;
}

.popup__contents {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
  align-items: center;
}

/* Figma에서 좌우 반전된 이미지 */
.popup__image {
  display: block;
  width: 80px;
  height: 80px;
  object-fit: cover;
  transform: scaleX(-1);
}

.popup__text {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 4px;
  text-align: center;
}

.popup__title {
  font-size: 18px;
  font-weight: 600;
  line-height: 1.5;
  color: var(--color-text-heavy);
}

.popup__message {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  color: var(--color-text-strong);
}

.popup__buttons {
  display: flex;
  width: 100%;
  gap: 4px;
  align-items: flex-end;
}

.popup__button {
  display: flex;
  flex: 1;
  min-width: 0;
  height: 54px;
  padding: 0 16px;
  justify-content: center;
  align-items: center;
  border-radius: 14px;
  font-size: 18px;
  font-weight: 500;
  line-height: 1.5;
  white-space: nowrap;
}

.popup__button--close {
  background: var(--color-secondary-light);
  color: var(--color-text-heavy);
}

.popup__button--confirm {
  background: var(--color-primary-normal);
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/page/FigmaTest.vue